// removed by extract-text-webpack-plugin
module.exports = {"appBurger":"Burger__appBurger__1A7nr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Burger/Burger.css
// module id = 240
// module chunks = 0